import httpClient from './httpClient';

const loginMensajeroRequest = (username, password) => {
    return httpClient.post('AppLogin/loginMensajero', {
        username,
        password
    });
};

export default loginMensajeroRequest;